module.exports = __webpack_public_path__ + "img/41.5c89f62d.png";